var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGostock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6042 22.0486V35.7145L35.7102 31.0733V17.4088L25.6042 22.0486Z",
    fill: "#2679B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2336 15.5151L23.7105 19.9326L33.1845 15.5151L23.7105 11.0955L14.2336 15.5151Z",
    fill: "#2679B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3386 31.0728L22.4445 35.714V22.0481L12.3386 17.4083V31.0728Z",
    fill: "#2679B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2549 10.7452 48 24 48C37.2549 48 48 37.2549 48 24C48 10.7452 37.2549 0 24 0ZM38.2213 33.1285L24.0484 39.5345L9.77874 33.0645V15.0637L23.7092 8.46554L38.2213 15.0637V33.1285V33.1285Z",
    fill: "#2679B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGostock);
export default __webpack_public_path__ + "static/media/gostock.ff47d25f.svg";
export { ForwardRef as ReactComponent };